export var Status;
(function (Status) {
    Status["PENDING"] = "PEN";
    Status["REFUSED"] = "REF";
    Status["ACCEPTED"] = "ACC";
})(Status || (Status = {}));
